import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class NavigationService {
  private readonly opened$$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  private readonly showNav$$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  readonly showNav$: Observable<boolean> = this.showNav$$.asObservable();

  get opened$(): Observable<boolean> {
    return this.opened$$.asObservable();
  }

  toggleNav(): void {
    this.opened$$.next(!this.opened$$.getValue());
  }

  setOpen(open: boolean): void {
    this.opened$$.next(open);
  }

  removeNav(): void {
    this.showNav$$.next(false);
  }
}
